import React from "react"
import styled from "styled-components"
import { FaTools, FaRecycle } from "react-icons/fa"

const ContainerImp = styled.div`
  .center-icon {
    width: 30px;
    display: inline-block;
    padding-right: 10px;
    margin-top: -5px;
  }
  h3 {
    font-weight: bold;
  }
  h3,
  li {
    color: #14a0ff;
    font-size: 1rem;
    letter-spacing: 0.7px;
  }
  li b {
    padding-right: 10px;
  }
  h1 {
    color: #191851;
    font-size: 44px;
    font-weight: bold;
    line-height: 60px;
  }
  h4,
  p {
    color: #576573;
    font-size: 1rem;
    line-height: 30px;
  }
  .ancor {
    color: #1465ff;
  }
  @media (max-width: 1024px) {
    padding: 20px;
  }
  @media (max-width: 592px) {
    h1 {
      line-height: 50px;
      font-size: 34px;
    }
  }
`

const options = [
  "<b>✓</b> Descarga de ClausERP.com los formatos en excel para hacer la migración automática de los datos de tu empresa.",
  "<b>✓</b> Diligencia los formatos en excel de acuerdo a las instrucciones que encontrarás en cada uno de ellos.",
  "<b>✓</b> Importa automáticamente tus clientes, proveedores, empleados y vendedores.",
  "<b>✓</b> Importa los productos o servicios que vende tu empresa y el cronograma de visitas de tus vendedores.",
  "<b>✓</b> Graba o importa los saldos iniciales de tu contabilidad.",
  "<b>✓</b> Configura tu factura electrónica",
]

const createMarkUp = text => {
  return { __html: text }
}

const ContainerImplementation = () => {
  return (
    <ContainerImp className="container py-10">
      <h1 className="p-4 text-center">Implementación de clausERP.com</h1>
      <br />
      <h3 className="px-4 py-2">
        <FaTools className="center-icon" /> Configuración
      </h3>
      <p className="px-4 py-2">
        En pocos pasos podrás configurar e implementar tu empresa en{" "}
        <b>ClausERP.com</b>, definiendo primero las responsabilidades
        tributarias y la fecha a partir de la cual deseas grabar tus documentos.
      </p>
      <br />
      <h3 className="px-4 py-2">
        <FaRecycle className="center-icon" /> Implementación
      </h3>
      <ul className="px-4 py-2">
        {options &&
          options.map((option, i) => {
            return (
              <li key={i}>
                <span dangerouslySetInnerHTML={createMarkUp(option)}></span>
              </li>
            )
          })}
      </ul>
      <br />
      <p className="px-4 py-2">
        El detalle de los pasos a seguir los encontrarás en la
        auto-capacitación:{" "}
        <a
          className="ancor"
          href="http://old.clauserp.com/ayuda/como-empezar-software-erp-contabilidad.php"
          rel="noopener noreferrer"
          target="_blank"
        >
          ¿Cómo empezar?
        </a>{" "}
      </p>
    </ContainerImp>
  )
}

export default ContainerImplementation
